module.exports = __webpack_public_path__ + "img/zhaf_02.3ad565dc.jpg";